import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import BlogCard from '../components/BlogCard';
import { blogPosts, getAllCategories, getFeaturedPosts } from '../data/blogData';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const categories = ["All", ...getAllCategories()];

  // Get featured posts
  const featuredPosts = getFeaturedPosts();

  // Filter posts based on selected category
  const filteredPosts = selectedCategory === "All"
    ? blogPosts
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <>
      {/* Hero Section */}
      <section style={{
        height: '50vh',
        background: 'linear-gradient(rgba(31, 61, 43, 0.85), rgba(31, 61, 43, 0.95)), url(https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80) center/cover no-repeat',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container>
          <Row>
            <Col lg={8} className="text-white">
              <h1 className="display-3 fw-bold mb-4" style={{ color: "#B59A5A" }}>Golf Insights & Articles</h1>
              <p className="lead" style={{ fontSize: '1.25rem', opacity: 0.9 }}>
                Expert articles, tips, and news to help you improve your game and stay updated with the golf industry
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Categories Filter */}
      <section className="section-padding-sm bg-soft-sage">
        <Container>
          <Row>
            <Col>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {categories.map((category, index) => (
                  <button
                    key={index}
                    className={`btn ${selectedCategory === category ? 'btn-gold-filled' : 'btn-gold'}`}
                    style={{ padding: '10px 24px', borderRadius: '25px' }}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Posts */}
      {featuredPosts.length > 0 && (
        <section className="section-padding">
          <Container>
            <Row className="mb-5">
              <Col lg={8}>
                <h2 className="display-5 fw-bold mb-3">Featured Articles</h2>
                <p style={{ color: '#666' }}>
                  Our most popular and insightful articles handpicked by our golf experts
                </p>
              </Col>
            </Row>

            <Row className="g-4 mb-5">
              {featuredPosts.map((post) => (
                <Col lg={4} md={6} key={post.id}>
                  <BlogCard {...post} />
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      {/* All Blog Posts */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col lg={8}>
              <h2 className="display-5 fw-bold mb-3">
                {selectedCategory === "All" ? "All Articles" : `${selectedCategory} Articles`}
              </h2>
              <p style={{ color: '#666' }}>
                {selectedCategory === "All"
                  ? "Browse our complete collection of golf articles and insights"
                  : `Articles related to ${selectedCategory}`
                }
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <div className="d-flex align-items-center justify-content-end">
                <span className="me-2" style={{ color: '#666' }}>Showing:</span>
                <span className="fw-bold" style={{ color: 'var(--muted-gold)' }}>
                  {filteredPosts.length} {filteredPosts.length === 1 ? 'article' : 'articles'}
                </span>
              </div>
            </Col>
          </Row>

          {filteredPosts.length > 0 ? (
            <Row className="g-4">
              {filteredPosts.map((post) => (
                <Col lg={4} md={6} key={post.id}>
                  <div className="animate-fade-in-up">
                    <BlogCard {...post} />
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <Row>
              <Col className="text-center py-5">
                <div style={{ fontSize: '4rem', color: 'var(--soft-sage)', marginBottom: '1rem' }}>
                  🏌️
                </div>
                <h3 className="h4 mb-3" style={{ color: 'var(--primary-green)' }}>
                  No articles found in this category
                </h3>
                <p style={{ color: '#666' }}>
                  Try selecting a different category or check back soon for new content
                </p>
                <button
                  className="btn-gold mt-3"
                  onClick={() => setSelectedCategory("All")}
                >
                  View All Articles
                </button>
              </Col>
            </Row>
          )}

          {/* Category Stats */}
          <Row className="mt-5 pt-5 border-top">
            <Col className="text-center">
              <div className="d-flex flex-wrap justify-content-center gap-4">
                <div>
                  <h3 className="h2 mb-1" style={{ color: 'var(--muted-gold)' }}>{blogPosts.length}</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Total Articles</p>
                </div>
                <div>
                  <h3 className="h2 mb-1" style={{ color: 'var(--muted-gold)' }}>{getAllCategories().length}</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Categories</p>
                </div>
                <div>
                  <h3 className="h2 mb-1" style={{ color: 'var(--muted-gold)' }}>6+</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Expert Authors</p>
                </div>
                <div>
                  <h3 className="h2 mb-1" style={{ color: 'var(--muted-gold)' }}>98%</h3>
                  <p className="mb-0" style={{ color: '#666' }}>Reader Satisfaction</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Newsletter Subscription */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              <div className="p-5 rounded text-center" style={{
                background: 'linear-gradient(135deg, var(--primary-green) 0%, #2a4d3b 100%)',
                color: 'white'
              }}>
                <div className="mb-4">
                  <div style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1.5rem'
                  }}>
                    <span style={{ fontSize: '2rem' }}>📧</span>
                  </div>
                  <h3 className="h2 mb-3">Never Miss an Update</h3>
                  <p className="mb-4" style={{ opacity: 0.9 }}>
                    Subscribe to our newsletter and get the latest golf tips, industry insights,
                    and exclusive content delivered directly to your inbox
                  </p>
                </div>
                <div className="input-group mx-auto" style={{ maxWidth: '500px' }}>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email address"
                    style={{
                      padding: '15px',
                      border: 'none',
                      borderRadius: '8px 0 0 8px'
                    }}
                  />
                  <button
                    className="btn-gold-filled"
                    type="button"
                    style={{
                      borderRadius: '0 8px 8px 0',
                      background: 'white',
                      color: 'var(--primary-green)',
                      border: 'none'
                    }}
                  >
                    Subscribe
                  </button>
                </div>
                <p className="small mt-3 mb-0" style={{ opacity: 0.7 }}>
                  We respect your privacy. Unsubscribe at any time. No spam, ever.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Popular Categories */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Explore by Category</h2>
              <p style={{ color: '#666' }}>
                Browse articles based on your interests and skill level
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {getAllCategories().map((category, index) => {
              const categoryPosts = blogPosts.filter(post => post.category === category);
              return (
                <Col lg={3} md={6} key={index}>
                  <div
                    className="p-4 text-center bg-white rounded h-100 cursor-pointer"
                    style={{
                      transition: 'all 0.3s ease',
                      border: '2px solid transparent'
                    }}
                    onClick={() => setSelectedCategory(category)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = 'var(--muted-gold)';
                      e.currentTarget.style.transform = 'translateY(-5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = 'transparent';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: 'var(--soft-sage)',
                      borderRadius: '50%',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem',
                      marginBottom: '1rem'
                    }}>
                      {category === "Technology" && "📱"}
                      {category === "Academy" && "🏌️"}
                      {category === "Industry Insights" && "💡"}
                      {category === "Business" && "💰"}
                      {category === "Corporate" && "🏢"}
                      {category === "Sustainability" && "🌱"}
                    </div>
                    <h4 className="h5 mb-2" style={{ color: 'var(--primary-green)' }}>
                      {category}
                    </h4>
                    <p className="small mb-0" style={{ color: '#666' }}>
                      {categoryPosts.length} {categoryPosts.length === 1 ? 'article' : 'articles'}
                    </p>
                  </div>
                </Col>
              );
            })}
          </Row>

          <Row className="mt-5">
            <Col className="text-center">
              <button
                className="btn-gold"
                onClick={() => setSelectedCategory("All")}
                style={{ padding: '12px 40px' }}
              >
                View All Categories
              </button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Blog;